const PdfViewer = ({ link }) => {
  return <iframe src={link} width="100%" height="1000"></iframe>;
};

export default PdfViewer;
